import styled, { css } from "styled-components";

const EditableGridWrapper = styled.section`
    h6 {
        font-size: 1.6rem;
    }
`;

const EditableGridCont = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
`;

const AddressGridWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    @media only screen and (min-width: ${props => props.theme.tablet}) {
        flex-direction: row;
    }
    & > div {
        position: relative;
        margin-top: 0;
        width: 100%;
        margin-right: 2rem;

        justify-content: space-between;
        flex-direction: column;
        flex-wrap: wrap;
        min-height: 24rem;
        @media only screen and (min-width: ${props => props.theme.tablet}) {
            min-height: 27rem;
            display: flex;
            width: calc(50% - 2rem);
        }

        @media only screen and (min-width: ${props => props.theme.desktop}) {
            width: calc(25% - 2rem);
        }
    }
`;

const EditableGridInfo = styled.div`
    padding-right: 1rem;
    position: relative;
    ${props =>
        props.type &&
        css`
            &:before {
                content: "";
                width: 3rem;
                height: 3rem;
                background-position: left center;
                position: absolute;
                right: 2rem;
                top: 0.1rem;
                background-repeat: no-repeat;
            }
        `}
        ${props =>
            props.type === "contact" &&
            css`
                &:before {
                    background-image: url(${props.theme.contactIcon});
                }
            `}
            ${props =>
                props.type === "personal" &&
                css`
                    &:before {
                        background-image: url(${props.theme.personalIcon});
                    }
                `}
    
h6 {
    max-width: 19rem;
    font-size: 1.4rem;
    margin-bottom: 0;
    color: ${props => props.theme.darkGreen};
  }
  h5 {
    font-size: 1.6rem;
    margin-bottom: 0;
  }
  p { 
    font-size: 1.4rem;
    padding-right: 3rem;
    margin-bottom: 1.2rem;
    ${props =>
        props.transactions &&
        css`
            font-size: 1.2rem;
            color: ${props.theme.lightGray4};
        `}
  }
  .profile {
    &__note {
      font-size: 1.2rem;
      margin-bottom: 0;
      color: ${props => props.theme.lightGray4};
    }
    &__name {
      margin-bottom: 0;
    }
  }
  h4 {
    color: ${props => props.theme.darkGreen};
    @media only screen and (min-width: ${props => props.theme.tablet}) {
      font-size: 2.4rem;
    }
  }
  .infoContainer__edit {
    color:  ${props => props.theme.lightGreen};
    font-weight: bold;
    position: absolute;
    right: 2rem;
    font-size: 1.4rem;
    bottom: 2rem;
    text-decoration: none;
    border: ${props => props.theme.lightGrayBorder};
    border-radius: 0.3rem;
    padding: 1rem 1rem 0.5rem 0.5rem; 
    height: 2rem;
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
      top: 3rem;
      padding: 0;
      border: none;
    }
    svg {
      margin-left: 1rem;
    }
    .edit__text {
      padding-bottom: 2rem;
      position: absolute;
      left: -3rem;  
      top: -0.2rem;
      display: none;
      @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        display: block; 
      }
    }
  }
  .deliveryAddress {
    margin: 0.5rem 0;
    position: relative;
    padding-left: 2.5rem;
    font-size: 1.2rem;
    color:  ${props => props.theme.lightGray4};
    &:before {
        content: "";
        width: 1.5rem;
        height: auto;
        background-position: bottom 0.3rem right;
        position: absolute;
        left: 0rem;
        top: 0.1rem;
        bottom: 0.7rem;
        background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxMiA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1OS4xICg4NjE0NCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R2xvYmFsL0F0b21zL0ljb25zL1RpY2sgZ3JlZW48L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBpZD0iU2Vjb25kYXJ5LXRleHQvbGVmdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC03LjAwMDAwMCkiIHN0cm9rZT0iIzAwQTc2QSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdsb2JhbC9BdG9tcy9JY29ucy9UaWNrLWdyZWVuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxLjExMTYyNzgzIiB5MT0iMy4wNzk1MTI4MyIgeDI9IjQuMDk3NzQxOTQiIHkyPSI2LjIxNDkzMjY0IiBpZD0iU3Ryb2tlLTIzIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTAuMjI4NjcxNyIgeTE9IjAiIHgyPSI0LjIxMDUwNzE5IiB5Mj0iNi4yODI2NTAzNyIgaWQ9IlN0cm9rZS0yNSI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
        background-size: 1.4rem;
        background-repeat: no-repeat;
    }
  }
`;

const AddressWrapper = styled.div`
    width: 50%;
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        width: 100%;
    }
    padding-top: 2rem;
    p {
        font-size: 1.4rem;
        @media only screen and (min-width: ${props => props.theme.tablet}) {
            font-size: 1.6rem;
        }
        margin-bottom: 0;
    }
`;

const EditableGridItem = styled.div`
    width: 100%;
    border: ${props => props.theme.lightGrayBorder};
    border-radius: 0.5rem;
    padding: 2rem;
    ${props =>
        props.transactions &&
        css`
            padding: 2.8rem 2.8rem 1.8rem;
        `}
    padding-right: 0;
    margin-bottom: 1rem;
    ${props =>
        !props.addresses &&
        css`
            @media only screen and (min-width: ${props.theme.smallTablet}) {
                display: flex;
                justify-content: space-between;
            }
        `}
`;

const EditableGridBtns = styled.div`
    display: flex;
    justify-content: flex-end;
    p {
        margin-bottom: 0;
        padding: 1.2rem 0;
        padding-right: 1rem;
    }
    ${props =>
        props.transactions &&
        css`
            padding-right: 2rem;
            margin-top: -1rem;
        `}

    ${props =>
        props.addresses &&
        css`
            justify-content: flex-start;
        `}

    ${props =>
        !props.addresses &&
        css`
            p {
                display: none;
            }
            @media only screen and (min-width: ${props.theme.smallTablet}) {
                justify-content: space-between;
                p {
                    display: block;
                }
            }
        `}
   

`;

const PriceDisplay = styled.div`
    background: ${props => props.theme.lightGray};
    margin-right: 1rem;
    border-radius: 0.5rem;
    padding: 2rem;
    border: 0;
    max-height: 8rem;
    h5 {
        margin-bottom: 0;
        padding-top: 0.5rem;
        font-size: 1.4rem;
        @media only screen and (min-width: ${props => props.theme.smallTablet}) {
            h5 {
                font-size: 2.1rem;
            }
        }
    }
`;

const EditableGridBtn = styled.button`
    border: 1px solid #D9D9D6;
    margin-right: 1rem;
    border-radius: 0.5rem;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    p {
        color:  ${props => props.theme.lightGreen};
        font-family: ${props => props.theme.fontBold};  
        font-weight: bold;
        font-size: 1.4rem;
    }
    .icon {
        margin-left: 2.7rem;

		&.order-history {
			width: 2rem;
			height: 2rem;
			margin: auto;
			background-image: none;
		}
    }
    h4 {
        padding-top: 1.5rem;
    }
    ${props =>
        props.addresses &&
        css`
            border: 0;
            padding: 0;
            .icon {
                margin-left: 0;
                width: 4rem;
                height: 5.2rem;
            }
        `}
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        border: 0;
        .icon {
            margin-left: 0;
            width: 4rem;
            height: 5.2rem;
        }
    }
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        h4 {
            padding-top: 1rem;
        }
    }
    ${props =>
        props.price &&
        css`
            background: ${props.theme.lightGray};
            padding: 2rem;
            border: 0;
            max-height: 8rem;
            h5 {
                margin-bottom: 0;
                padding-top: 0.5rem;
                font-size: 1.4rem;
                @media only screen and (min-width: ${props.theme.smallTablet}) {
                    h5 {
                        font-size: 2.1rem;
                    }
                }
            }
        `}
    ${props =>
        props.delete &&
        css`
            p {
                color: ${props.theme.darkBlue};
            }
        `}
`;

const EditableGridLink = styled.button`
    padding-left: 0;
    padding-top: 2rem;
    font-family: ${props => props.theme.fontBold};
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    margin-right: 2rem;
    width: 100%;
    margin-bottom: 2rem;
    position: relative;
    &:after {
        content: "";
        width: 3rem;
        height: 3rem;
        background-position: left center;
        position: absolute;
        right: 2rem;
        top: 1.2rem;
        background-repeat: no-repeat;
        ${props =>
            props.contact &&
            css`
                background-image: url(${props.theme.contactIcon});
            `}

        ${props =>
            props.personal &&
            css`
                background-image: url(${props.theme.personalIcon});
            `}
    }
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        width: 27rem;
    }
`;

const EditableGridContBtns = styled.div`
    margin-top: 2rem;
`;

const PagingSelect = styled.div`
    width: 24rem;
`;

const SearchWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
`;

const SearchIcon = styled.span`
    position: absolute;
    top: 2rem;
    right: 2rem;
`;

const DeletePrompt = styled.div`
    padding: 1rem;
    border: ${props => props.theme.redBorder};
    margin-right: 2rem;
    border-radius: 0.5rem;
    width: 32rem;
    color: ${props => props.theme.lightGreen};
    font-size: 1.4rem;
    span {
        font-family: ${props => props.theme.fontBold};
        font-weight: bold;
        font-size: 1.4rem;
    }
    .deleteHeading {
        font-size: 1.4rem;
        text-align: center;
        padding-bottom: 0.5rem;
    }

    ${props =>
        props.addresses &&
        css`
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${props.theme.white};
            text-align: center;
            p {
                font-size: 1.4rem;
                color: ${props.theme.black};
                font-weight: bold;
                padding-top: 0;
            }
            .icon-warning {
                margin: auto;
            }
        `}
`;

export {
    EditableGridWrapper,
    EditableGridItem,
    EditableGridBtns,
    EditableGridBtn,
    EditableGridInfo,
    EditableGridCont,
    EditableGridLink,
    PagingSelect,
    SearchWrapper,
    SearchIcon,
    DeletePrompt,
    AddressWrapper,
    AddressGridWrapper,
    EditableGridContBtns,
    PriceDisplay
};
